<main class="main">
    <div class="container">
        <div class="pageHeader d-flex justify-content-between">
            <h1 class=" mb-4">Sync RCM Master Data</h1>
        </div>
        <div class="card-body">
            <form #filterForm="ngForm" class="navbar-form" class="form-floating">
                <div class="row m-0  searchRecordWrapper">
                    <p class="error textError m-0" *ngIf="errorMessage!=null">
                        {{errorMessage}}
                    </p>
                    <div class="col-12 mb-3 mt-3 d-flex align-items-end">
                        <div class="form-floating flex-grow-1 me-3">
                            <ng-select #table [items]="masterTablesOptionsList" bindLabel="TableName" bindValue="MasterTableId"
                                [multiple]="true" [closeOnSelect]="false" class="form-control form-select" id="txtTable"
                                [(ngModel)]="selectedTableIds" [ngModelOptions]="{standalone: true}">
                    
                                <ng-template ng-option-tmp let-item="item" let-item$="item$" let-index="index">
                                    <input id="item-{{index}}" type="checkbox" name="item-{{index}}" [ngModel]="item$.selected"
                                        [checked]="true" /> {{item.TableName}}
                                </ng-template>
                            </ng-select>
                            <label for="txtTableName">Master Data</label>
                        </div>
                    
                        <div class="col-3">
                            <div class="d-flex justify-content-center align-items-center">
                                <button class="btn btn-primary smallBtn" type="submit" (click)="submit()">Sync Reglake
                                    Data With RCM</button>
                                <!-- <button class="btn btn-primary smallBtn" type="submit" (click)="GetSyncRcmDataToXLS()"> Export Sync RCM Data</button> -->
                            </div>
                        </div>
                    </div>

                </div>
            </form>
        </div>
        
        <div class="pageHeader d-flex justify-content-between">
            <h1 class=" mb-4">Sync Master Data Details</h1>
        </div>
        
        <div class="card-body rlSearchCard scrollTo">
            <div class="row m-0">
                <div class="col-12 table-responsive">
                    <table class="table table-bordered">
                        <thead>
                            <tr style="border-bottom-width: 0px">
                                <th style="width: 35%; min-width: 200px;">
                                    <div class="d-flex justify-content-between align-items-center" (click)="sortData('TableNames')"
                                        style="cursor: pointer;">
                                        <span>Master Field</span>
                                        <span>
                                            <i class="fa" [ngClass]="{
                                                'fa-sort-asc': pagination.columnName === 'TableNames' && pagination.ascending,
                                                'fa-sort-desc': pagination.columnName === 'TableNames' && !pagination.ascending
                                            }" *ngIf="pagination.columnName === 'TableNames'"></i>
                                            <i class="fa fa-sort-asc" *ngIf="!pagination.columnName && 'TableNames' === getDefaultSortColumn()"></i>
                                        </span>
                                    </div>
                                </th>

                                <th style="width: 5%; min-width: 50px;">
                                    <div class="d-flex justify-content-between align-items-center" (click)="sortData('LastUpdatedDate')"
                                        style="cursor: pointer;">
                                        <span>Last Updated On</span>
                                        <span>
                                            <i class="fa" [ngClass]="{
                                                'fa-sort-asc': pagination.columnName === 'LastUpdatedDate' && pagination.ascending,
                                                'fa-sort-desc': pagination.columnName === 'LastUpdatedDate' && !pagination.ascending
                                            }" *ngIf="pagination.columnName === 'LastUpdatedDate'"></i>
                                        </span>
                                    </div>
                                </th>
                            </tr>
                            <tr>
                                <th style="width: 35%;min-width:130px;">
                                    <form (ngSubmit)="$event.preventDefault()">
                                        <div class="d-flex">
                                            <div class="form-floating flex-grow-1">
                                                <input type="text" class="form-control filterSearch" placeholder="Search..."
                                                    [ngModelOptions]="{standalone: true}" [(ngModel)]="filters.TableName" (input)="applyFilters()">
                                                <label>Search</label>
                                            </div>
                            
                                            <div class="btn-group moreOptWrapper" dropdown [autoClose]="true" [insideClick]="true">
                                                <button dropdownToggle type="button" class="dropdown-toggle filterToggle" title="More options">
                                                    <i class="fa fa-filter filterIcon"></i>
                                                </button>
                            
                                                <ul *dropdownMenu class="dropdown-menu RLFilter" style="margin-left: -128px">
                                                    <li *ngFor="let item of columnDropdownFilter; let i = index"
                                                        [ngClass]="{'active': item.activeTableName}">
                                                        <a class="dropdown-item" (click)="applyFilterOption('TableName', i)">
                                                            {{ item.name }}
                                                            <i class="fa fa-check ms-2" *ngIf="item.activeTableName"></i>
                                                        </a>
                                                    </li>
                                                </ul>
                                            </div>
                                        </div>
                                    </form>
                                </th>
                                <th style="width: 5%;min-width:50px;">
                                    <form (ngSubmit)="$event.preventDefault()">
                                        <div class="d-flex">
                                            <div class="form-floating flex-grow-1">
                                                <input type="text" class="form-control filterSearch" placeholder="Search..."
                                                    [ngModelOptions]="{standalone: true}" [(ngModel)]="filters.LastUpdatedOn"
                                                    (input)="applyFilters()">
                                                <label>Search</label>
                                            </div>
                            
                                            <div class="btn-group moreOptWrapper" dropdown [autoClose]="true" [insideClick]="true">
                                                <button dropdownToggle type="button" class="dropdown-toggle filterToggle" title="More options">
                                                    <i class="fa fa-filter filterIcon"></i>
                                                </button>
                            
                                                <ul *dropdownMenu class="dropdown-menu RLFilter" style="margin-left: -128px">
                                                    <li *ngFor="let item of columnDropdownFilter; let i = index"
                                                        [ngClass]="{'active': item.activeLastUpdatedOn}">
                                                        <a class="dropdown-item" (click)="applyFilterOption('LastUpdatedOn', i)">
                                                            {{ item.name }}
                                                            <i class="fa fa-check ms-2" *ngIf="item.activeLastUpdatedOn"></i>
                                                        </a>
                                                    </li>
                                                </ul>
                                            </div>
                                        </div>
                                    </form>
                                </th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr *ngIf="pagedSyncMasterData?.length==0">
                                <td attr.colspan="{{colSpan}}" class="text-center"
                                    style="padding-top: 70px; padding-bottom: 70px;">
                                    <h6 class="text-center" style="color: red;" *ngIf="SyncMasterData?.length==0">
                                        No Record Found
                                    </h6>
                                </td>
                            </tr>
                            <tr *ngFor="let data of pagedSyncMasterData;let i=index;">
                                <td style="width: 35%;" class="ellipsis" title="{{data.TableNames}}">
                                    {{data.TableNames}}
                                </td>
                                <td style="width: 5%;" class="ellipsis" title="{{data.LastUpdatedDate|date:'MM/dd/YYYY hh:mm a'}}">
                                    {{data.LastUpdatedDate|date:'MM/dd/YYYY hh:mm a'}}
                                </td>
                            </tr>
                            <tr *ngIf="SyncMasterData?.length<=4 && SyncMasterData?.length!=0">
                                <td attr.colspan="{{colSpan}}" class="text-center" style="padding-bottom: 142px;">
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
            
            <!-- Pagination Section -->
            <div class="row clear-fix col-12 mt-2">
                <div class="col-3 ps-4 d-flex">
                    <div class="form-floating p-1">
                        <select class="form-select form-control paginationDropdown" id="floatingSelect"
                            [(ngModel)]="pagination.pageLength" (change)="GetDataByPageLength()">
                            <option value="50">50</option>
                            <option value="100">100</option>
                            <option value="250">250</option>
                            <option value="500">500</option>
                            <option value="750">750</option>
                            <option value="1000">1000</option>
                        </select>
                    </div>
                    <label for="floatingSelect" class="mt-2 pt-2 ms-2">Items per page</label>
                </div>

                <div class="col-9 m-0 float-right">
                    <div class="row p-0">
                        <div class="col-4 mt-3 p-0 text-center">
                            <h6 *ngIf="totalRecordsForPagination != 0">
                                {{ totalRecordsForPagination }} items found
                            </h6>
                        </div>

                        <div class="col-8 p-0 m-0" *ngIf="totalPages > 1">
                            <app-pagination [totalPages]="totalPages" [currentPage]="currentPage"
                                (pageChanged)="setPage($event)">
                            </app-pagination>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</main>

<app-loader [showLoader]="showLoader"></app-loader>
<notifier-container></notifier-container>